export const AUTH_COOKIES = {
    DWSID_TOKEN: 'dwsid',
    ACCESS_TOKEN: 'accessToken',
    LAST_ACTIVE: 'lastActive',
    PETM_ANONYMOUS_KEY: 'petmAnonymousKey',
    PETM_CUSTOMER_KEY: 'petmCustomerKey',
    RECAPTCHA_IS_CHECKBOX: 'rcIsCbx',
    RECAPTCHA_TOKEN: 'rcToken',
    RECAPTCHA_TOKEN_CHECKBOX: 'rcTokenCbx',
    REFRESH_TOKEN: 'refreshToken',
    RESET_PW_EMAIL: 'resetPwEmail',
    TOKEN_EXPIRY: 'tokenExpiry',
};

export const COOKIES = {
    CART_ID: 'ctCartId',
    ORDER_ID: 'orderId',
    KOUNT_ID: 'kountId',
    IS_SHIPPING_OPTION_CONFIRMED: 'isShippingOptionConfirmed',
};

export const OKTA_COOKIES = {
    OKTA_ACCESS_TOKEN: 'oktaAccessToken',
    OKTA_TOKEN_TYPE: 'oktaTokenType',
    OCTA_SCOPE: 'oktaScope',
    OKTA_REFRESH_TOKEN: 'oktaRefreshToken',
    OKTA_ID_TOKEN: 'oktaIdToken',
};

export const OG_COOKIE = 'og_auth';
